import React, { useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices, useUploadImage } from 'hook/services';
import Multiselect from './components/Multiselect';
import { Button, Stack } from '@mui/material';
import Editor from 'components/editor'

const EditModal = ({ data, handleRefresh, apps,category }) => {
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [svgIcon, setSvgIcon] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [description,setDescription] = useState(data.description)
  const uploadImage = useUploadImage()

  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0]);
  };

  const appOptions = apps?.map(item => ({
    label: item?.name,
    value: item?.app_id,
  }))


const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setProcessing(true);

  const selectedApps = JSON.parse(e.target.apps.value)
  // Ensure all required fields are present
  const payload = {
    _id:data._id,
    name: e.target.name.value,
    key:e.target.key.value,
    category: e.target.category.value,
    description,
    video_path: e.target.video_path.value,
    app_id: selectedApps ? selectedApps : [],
  };



     const { response } = await AppService.Tools.update({
      payload
  });

      if (response) {
          setProcessing(false);
          setOpenEditProduct(false);
          handleRefresh();
      }
};




  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} encType="multipart/form-data">
            <MDTypography variant="h5" mb={2}>
              Edit Tool
            </MDTypography>

            <MDBox mb={2}>
                          <MDTypography variant="button">Name</MDTypography>
                          <MDInput label="Name" name="name" defaultValue={data.name} fullWidth required />
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography variant="button">Key</MDTypography>
                          <MDInput label="Key" name="key" defaultValue={data.key} fullWidth required />
                        </MDBox>
                        <MDBox sx={{ fontSize: '15px' }}>
                          <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                            Apps
                          </MDTypography>
                          <Multiselect data={appOptions} isMulti={true} name="apps" edit_data={data?.app_id}/>
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography variant="button">Category</MDTypography>
                          <MDInput
                            select
                            name="category"
                            fullWidth
                            defaultValue={data.category._id}
                            required
                            SelectProps={{ native: true }}
                          >
                            <option value="">Select a Category</option>
                            {category?.map((cat) => (
                              <option key={cat._id} value={cat._id}>
                                {cat.name}
                              </option>
                            ))}
                          </MDInput>
                        </MDBox>
            
            
            
            
            
                        <MDBox mb={2}>
                          <MDTypography variant="button">Description</MDTypography>
                          <Editor handleChange={setDescription} data={description}/>
                        </MDBox>
            
                        <MDBox mb={2}>
                          <MDTypography variant="button">Video URL</MDTypography>
                          <MDInput label="Video URL" name="video_path" defaultValue={data.video_path} fullWidth />
                        </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditModal;
